import React, { useState } from "react";

import Image from "components/AppImage";

const properties = [
{
  id: 1,
  address: "5412 Farnam Street",
  city: "Omaha, NE",
  price: 285000,
  roi: 8.4,
  capRate: 6.8,
  cashOnCash: 7.2,
  riskScore: 2,
  riskLabel: "Low",
  monthlyRent: 1950,
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_14bc3b931-1772578641582.png",
  imageAlt: "Two-story brick colonial house with green lawn and mature maple trees in Omaha Midtown neighborhood",
  badge: "Top Pick",
  badgeColor: "success"
},
{
  id: 2,
  address: "3218 Dodge Street",
  city: "Dundee, Omaha NE",
  price: 248000,
  roi: 7.9,
  capRate: 6.2,
  cashOnCash: 6.8,
  riskScore: 3,
  riskLabel: "Medium",
  monthlyRent: 1720,
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1596430f0-1772578640615.png",
  imageAlt: "Charming craftsman bungalow with covered front porch and mature trees in Omaha Dundee neighborhood",
  badge: "High Yield",
  badgeColor: "primary"
},
{
  id: 3,
  address: "1842 S 48th Street",
  city: "Aksarben, Omaha NE",
  price: 215000,
  roi: 7.1,
  capRate: 5.9,
  cashOnCash: 6.1,
  riskScore: 2,
  riskLabel: "Low",
  monthlyRent: 1480,
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1a9981765-1772578640070.png",
  imageAlt: "Classic brick ranch home with stone steps and well-maintained landscaping in Omaha Aksarben neighborhood",
  badge: null,
  badgeColor: null
},
{
  id: 4,
  address: "14820 Arbor Street",
  city: "West Omaha, NE",
  price: 365000,
  roi: 6.8,
  capRate: 5.4,
  cashOnCash: 5.9,
  riskScore: 4,
  riskLabel: "High",
  monthlyRent: 2200,
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1789d6a79-1772578641202.png",
  imageAlt: "Single-story ranch style home with attached garage and manicured lawn in West Omaha suburb",
  badge: null,
  badgeColor: null
},
{
  id: 5,
  address: "602 Galvin Road S",
  city: "Bellevue, NE",
  price: 198000,
  roi: 6.2,
  capRate: 4.8,
  cashOnCash: 5.1,
  riskScore: 3,
  riskLabel: "Medium",
  monthlyRent: 1350,
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1a6335f2e-1772578641179.png",
  imageAlt: "Contemporary split-level home with attached garage and landscaped yard in Bellevue Nebraska",
  badge: null,
  badgeColor: null
}];


const riskColors = {
  Low: "text-success bg-success/10",
  Medium: "text-warning bg-warning/10",
  High: "text-accent bg-accent/10"
};

const badgeColors = {
  success: "bg-success text-success-foreground",
  primary: "bg-primary text-primary-foreground"
};

export default function OpportunityRanking({ targetROI }) {
  const [selected, setSelected] = useState(null);

  return (
    <div className="card-base flex flex-col gap-4 h-full">
      <div>
        <h3 className="font-heading font-semibold text-base text-foreground">
          Investment Opportunities
        </h3>
        <p className="text-xs font-caption text-muted-foreground mt-0.5">
          Ranked by ROI potential · Target: {targetROI}%
        </p>
      </div>
      <div className="flex flex-col gap-3 overflow-y-auto" style={{ maxHeight: 420 }}>
        {properties?.map((p, idx) => {
          const meetsTarget = p?.roi >= targetROI;
          return (
            <button
              key={p?.id}
              onClick={() => setSelected(selected === p?.id ? null : p?.id)}
              className={`w-full text-left rounded-xl border p-3 transition-standard ${
              selected === p?.id ?
              "border-primary bg-primary/5" : "border-border bg-background hover:bg-muted"}`
              }>
              
              <div className="flex items-start gap-3">
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-muted flex items-center justify-center text-xs font-caption font-bold text-muted-foreground">
                  {idx + 1}
                </span>
                <div className="w-12 h-12 rounded-lg overflow-hidden flex-shrink-0">
                  <Image
                    src={p?.image}
                    alt={p?.imageAlt}
                    className="w-full h-full object-cover" />
                  
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-start justify-between gap-2">
                    <div className="min-w-0">
                      <p className="text-sm font-heading font-semibold text-foreground truncate">
                        {p?.address}
                      </p>
                      <p className="text-xs font-caption text-muted-foreground">{p?.city}</p>
                    </div>
                    <div className="flex flex-col items-end gap-1 flex-shrink-0">
                      {p?.badge &&
                      <span className={`text-xs font-caption font-semibold px-2 py-0.5 rounded-full ${badgeColors?.[p?.badgeColor]}`}>
                          {p?.badge}
                        </span>
                      }
                      <span className={`text-xs font-caption font-medium px-2 py-0.5 rounded-full ${riskColors?.[p?.riskLabel]}`}>
                        {p?.riskLabel} Risk
                      </span>
                    </div>
                  </div>
                  <div className="flex items-center gap-3 mt-2 flex-wrap">
                    <span className={`text-sm font-mono-data font-bold ${meetsTarget ? "text-success" : "text-muted-foreground"}`}>
                      {p?.roi}% ROI
                    </span>
                    <span className="text-xs font-caption text-muted-foreground">
                      Cap: {p?.capRate}%
                    </span>
                    <span className="text-xs font-caption text-muted-foreground">
                      CoC: {p?.cashOnCash}%
                    </span>
                  </div>
                </div>
              </div>
              {selected === p?.id &&
              <div className="mt-3 pt-3 border-t border-border grid grid-cols-2 gap-2">
                  <div className="flex flex-col">
                    <span className="text-xs font-caption text-muted-foreground">Purchase Price</span>
                    <span className="text-sm font-mono-data font-semibold text-foreground">
                      ${p?.price?.toLocaleString()}
                    </span>
                  </div>
                  <div className="flex flex-col">
                    <span className="text-xs font-caption text-muted-foreground">Monthly Rent</span>
                    <span className="text-sm font-mono-data font-semibold text-foreground">
                      ${p?.monthlyRent?.toLocaleString()}
                    </span>
                  </div>
                  <div className="flex flex-col">
                    <span className="text-xs font-caption text-muted-foreground">Annual Income</span>
                    <span className="text-sm font-mono-data font-semibold text-foreground">
                      ${(p?.monthlyRent * 12)?.toLocaleString()}
                    </span>
                  </div>
                  <div className="flex flex-col">
                    <span className="text-xs font-caption text-muted-foreground">GRM</span>
                    <span className="text-sm font-mono-data font-semibold text-foreground">
                      {(p?.price / (p?.monthlyRent * 12))?.toFixed(1)}x
                    </span>
                  </div>
                </div>
              }
            </button>);

        })}
      </div>
    </div>);

}